import { render, staticRenderFns } from "./ProductCostSaldoMinusList.vue?vue&type=template&id=3b9b0df3&"
import script from "./ProductCostSaldoMinusList.vue?vue&type=script&lang=js&"
export * from "./ProductCostSaldoMinusList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports